import { useTranslation } from "react-i18next";
import {
  LoadingState as UiLoadingState,
  type LoadingStateProps as UiLoadingStateProps,
} from "@/components/ui/LoadingState";

export type LoadingStateProps = Omit<UiLoadingStateProps, "loadingLabel"> & {
  loadingLabel?: string;
};

/** App loading placeholder with default i18n message. */
export function LoadingState({ message, loadingLabel, ...props }: LoadingStateProps) {
  const { t } = useTranslation("common");
  return (
    <UiLoadingState
      loadingLabel={loadingLabel ?? t("loading")}
      message={message ?? t("loading")}
      {...props}
    />
  );
}
